import { useState } from "react";
import { getHtmlNewlines } from "../../helpers/templateHelpers";
import PropTypes from "prop-types";

function LongText(props) {
  const content = props.content;
  const limit = props.limit;

  const [showAll, setShowAll] = useState(false);

  const renderData = () => {
    if (content) {
      if (content.length <= limit) {
        return (
          <div className="text">
            <p
              dangerouslySetInnerHTML={{ __html: getHtmlNewlines(content) }}
            ></p>
          </div>
        );
      }
      if (showAll) {
        return (
          <div className="text">
            <p
              dangerouslySetInnerHTML={{ __html: getHtmlNewlines(content) }}
            ></p>
          </div>
        );
      }
      const toShow = content.substring(0, limit);
      return (
        <div className="text">
          <p
            dangerouslySetInnerHTML={{
              __html: getHtmlNewlines(toShow) + " ...",
            }}
          ></p>
          <a className="showMore" onClick={() => setShowAll(true)}>
            Pokaži več »
          </a>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  return <div>{renderData()}</div>;
}

export default LongText;

LongText.propTypes = {
  content: PropTypes.string,
  limit: PropTypes.number.isRequired,
};
